<template>
  <div
    class="ll-question-number-list"
    :class="{'mt-lg':isMtLg}"
  >
    <div class="ll-question-number-list_content">
      <p
        v-if="resultTotal"
        class="ll-question-number-list_title"
      >
        {{ $t("共{number}筆",{
          number:_totalNumber
        }) }} {{ $t("記錄") }}
      </p>
      <p
        v-else
        class="ll-question-number-list_title"
      >
        {{ $t("共{number}題",{
          number:_totalNumber
        }) }}
      </p>
      <div
        v-if="!onlyNumber"
        class="ll-question-number-list_numbers"
      >
        <div
          v-for="(number,numberIndex) in numberList"
          :key="numberIndex"
          class="ll-question-number-list_number"
        >
          <i
            class="ll-question-number-list_number-icon"
            :class="[`level${number.level}`,icon]"
          />
          <p class="ll-question-number-list_number-text">
            {{ number.title }}<span class="num">{{ number.number }}</span>
          </p>
        </div>
      </div>
    </div>
    <WsTextChip001
      v-if="text"
      class="mt-20"
      red
      thin
      font-size-xs
      icon-lg
      :text-label="text"
      :leading-icon="textIcon"
    />
  </div>
</template>
<script>
export default {
  name: "LlQuestionNumberList",
  props: {
    resultTotal: {
      type: Boolean,
      default: false,
    },
    onlyNumber: {
      type: Boolean,
      default: false,
    },
    numberList: {
      type: Array,
      default() {
        return [];
      },
    },
    textIcon: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    isMtLg: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "icon-warning-filled",
    },
    totalNumber: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    _totalNumber() {
      if (this.onlyNumber) {
        return this.totalNumber;
      } else {
        const allNumber = this.numberList.map((item) => item.number);
        const totalNumber = allNumber.reduce((a, b) => {
          return parseInt(a) + parseInt(b);
        }, 0);
        return totalNumber;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-question-number-list";
</style>